import { isValid, parseISO } from "date-fns";

export const validDashboardRange = ({ startDate, endDate }) =>
  Boolean(/^\d{4}-\d{2}-\d{2}$/.test(startDate || "") && /^\d{4}-\d{2}-\d{2}$/.test(endDate || "")
    && isValid(parseISO(startDate)) && isValid(parseISO(endDate)) && startDate <= endDate);

export const dashboardRangeLabel = (start, end) => {
  if (!validDashboardRange({ startDate: start, endDate: end })) return "Pilih rentang tanggal yang valid";
  const formatter = new Intl.DateTimeFormat("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  return `${formatter.format(parseISO(start))} – ${formatter.format(parseISO(end))}`;
};

export const metricComparison = (current, previous) => {
  if (previous == null || !Number.isFinite(Number(previous))) return null;
  const delta = Number(current) - Number(previous);
  const tone = delta > 0 ? "success" : delta < 0 ? "danger" : "secondary";
  if (delta === 0) return { label: "Tidak berubah", tone };
  if (Number(previous) === 0) return { label: delta > 0 ? "Naik dari nol" : "Turun dari nol", tone };
  const percent = (Math.abs(delta) / Math.abs(Number(previous))) * 100;
  return {
    label: `${delta > 0 ? "↑" : "↓"} ${percent.toLocaleString("id-ID", { maximumFractionDigits: 1 })}%`,
    tone,
  };
};
